import { ref } from "vue";
import { defineStore } from "pinia";

export const useConfirmDialogStore = defineStore("confirm-dialog", () => {
  const isOpen = ref(false);
  const currentEntity = ref("");
  const agreeText = ref('')
  const resolve = ref();

  const openDeleteDialog = () => {
    isOpen.value = true;
  };

  const confirm = async (entityName: string, callback: any, agree?: string) => {
    currentEntity.value = entityName;
    agreeText.value = agree || ''

    openDeleteDialog();

    await callback(
      new Promise((res) => {
        resolve.value = res;
      }),
    );
  };

  return {
    isOpen,
    currentEntity,
    resolve,
    confirm,
    agreeText
  };
});
